'use strict';

angular.module('licensure.helpers')
    .factory('Format', [function () {
        return {
            label: function (string) {
                var result;

                result = string.replace(/_/g, " ");
                result = result.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });

                return result;
            },

            date: function (date) {
                var day = date.getDate();        // yields day
                var month = date.getMonth()+1;    // yields month
                var year = date.getFullYear();  // yields year
                var hour = date.getHours();     // yields hours 
                var minute = date.getMinutes(); // yields minutes
                var second = date.getSeconds(); // yields seconds
                // After this construct a string with the above results as below
                return month + "/" + day + "/" + year + " " + hour + ':' + minute + ':' + second;
            },

            convertDateToUTC: function(date) {
                 return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
            },

            cyberSourceDate: function (date) {
                var day = date.getUTCDate();        // yields day
                var month = date.getUTCMonth() + 1;    // yields month
                var year = date.getUTCFullYear();  // yields year
                var hour = date.getUTCHours();     // yields hours 
                var minute = date.getUTCMinutes(); // yields minutes
                var second = date.getUTCSeconds(); // yields seconds
                // After this construct a string with the above results as below
                return year + "-" + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day) + "T" + (hour < 10 ? "0" + hour : hour) + ':' + (minute < 10 ? "0" + minute : minute) + ':' + (second < 10 ? "0" + second : second) + "Z";
            },

            evaluateJSON: function (record, field, revertTimeZone) {
                var value = record;

                if (field != '') {
                    field.split('.').forEach(function (partial) {
                        if (value != null) {
                            value = value[partial];
                        }
                    })
                }
                
                if (value instanceof Date) {
                    if (revertTimeZone) {
                        value = value.revertTimeZone();
                    }
                    //value = value.toLocaleDateString("en-US");
                }

                return value;
            },

            getDescendantProp: function (obj, desc, forceString) {
                if (obj != null && desc != null) {
                    var arr = desc.split(".");
                    while (arr.length && (obj = obj[arr.shift()]));
                }

                if (forceString) {
                    obj += '';
                }

                return obj;
            },

            fileSize: function (bytes) {
                var val = '';

                if (!isNaN(bytes)) {
                    bytes = +bytes;
                    if (bytes < 1024) {
                        val = bytes + ' b';
                    }
                    else if (bytes < Math.pow(1024,2)) {
                        val = Math.round(bytes / 1024, -2) + ' KB';
                    }
                    else if (bytes < Math.pow(1024, 3)) {
                        val = Math.round(bytes / Math.pow(1024, 2), -2) + ' MB';
                    }
                    else {
                        val = Math.round(bytes / Math.pow(1024, 3), -2) + ' GB';
                    }
                }
                else {
                    val = bytes;
                }

                return val;
            },

            underscore: function(original) {
                var newString = original.toLowerCase();
                var newString = newString.replace(" ", "_");
                return newString;
            },

            buildCSS: function (jsonString, isPublic) {
                if (jsonString == null) {
                    return "";
                }
                if (jsonString.indexOf("<style>") == 0) {
                    return jsonString;
                }
                var jsonObject = angular.fromJson(jsonString);
                var val = '<style>';

                if (typeof jsonObject.active_link != "undefined" && jsonObject.active_link) {
                    if (isHexColor(jsonObject.active_link)) {
                        jsonObject.active_link = "#" + jsonObject.active_link;
                    }
                    val += " #licensure .gutter ul li.active a, #licensure .gutter a:hover {";
                    val += "    border-bottom:3px solid " + jsonObject.active_link + "}";
                    val += " #licensure .navigation ul.selected li.level_0, #licensure .navigation li.level_0.selected,#licensure .navigation li.level_0:hover {";
                    val += "    border-left:5px solid " + jsonObject.active_link + "}";
                    val += " #licensure .license_container td.highlighted {";
                    val += "    border-left: 2px solid " + jsonObject.active_link + "}";
                }

                if (typeof jsonObject.background != "undefined" && jsonObject.background) {
                    if (isPublic) {
                        val += "body { background: #" + jsonObject.background[1] + "}";
                    }
                    val += " #licensure_wrapper, #portal_preview_section {";
                    val += "    background: #" + jsonObject.background[1] + "; /* Old browsers */";
                    val += "    background: -moz-linear-gradient(top, #" + jsonObject.background[0] + " 0%, #" + jsonObject.background[1] + " 100%); /* FF3.6+ */";
                    val += "    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#" + jsonObject.background[0] + "), color-stop(100%,#" + jsonObject.background[1] + ")); /* Chrome,Safari4+ */";
                    val += "    background: -webkit-linear-gradient(top,#" + jsonObject.background[0] + " 0%,#" + jsonObject.background[1] + " 100%); /* Chrome10+,Safari5.1+ */";
                    val += "    background: -o-linear-gradient(top, #" + jsonObject.background[0] + " 0%,#" + jsonObject.background[1] + " 100%); /* Opera 11.10+ */";
                    val += "    background: -ms-linear-gradient(top, #" + jsonObject.background[0] + " 0%,#" + jsonObject.background[1] + " 100%); /* IE10+ */";
                    val += "    background: linear-gradient(to bottom, #" + jsonObject.background[0] + " 0%,#" + jsonObject.background[1] + " 100%); /* W3C */";
                    val += "    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#" + jsonObject.background[0] + "', endColorstr='#" + jsonObject.background[1] + "',GradientType=0 ); /* IE6-8 */";
                    val += "}";
                }

                if (typeof jsonObject.button != "undefined" && jsonObject.button) {
                    val += " #licensure input[type='button'], #licensure input[type='submit'], #licensure input[type='reset'], #licensure span.button {";
                    val += "    background-color: #" + jsonObject.button[1] + ";";
                    val += "    border: 1px solid #" + jsonObject.button[0] + ";";
                    val += "    background: -moz-linear-gradient(top, #" + jsonObject.button[0] + " 0%, #" + jsonObject.button[1] + " 100%); /* FF3.6+ */";
                    val += "    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#" + jsonObject.button[0] + "), color-stop(100%,#" + jsonObject.button[1] + ")); /* Chrome,Safari4+ */";
                    val += "    background: -webkit-linear-gradient(top,#" + jsonObject.button[0] + " 0%,#" + jsonObject.button[1] + " 100%); /* Chrome10+,Safari5.1+ */";
                    val += "    background: -o-linear-gradient(top, #" + jsonObject.button[0] + " 0%,#" + jsonObject.button[1] + " 100%); /* Opera 11.10+ */";
                    val += "    background: -ms-linear-gradient(top, #" + jsonObject.button[0] + " 0%,#" + jsonObject.button[1] + " 100%); /* IE10+ */";
                    val += "    background: linear-gradient(to bottom, #" + jsonObject.button[0] + " 0%,#" + jsonObject.button[1] + " 100%); /* W3C */";
                    val += "    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#" + jsonObject.button[0] + "', endColorstr='#" + jsonObject.button[1] + "',GradientType=0 ); /* IE6-8 */";
                    val += "}";
                }

                if (typeof jsonObject.menu != "undefined" && jsonObject.menu) {
                    val += " #licensure .menu {";
                    val += "    background: #" + jsonObject.menu[1] + ";";
                    val += "    background: -moz-linear-gradient(top, #" + jsonObject.menu[0] + " 0%, #" + jsonObject.menu[1] + " 100%); /* FF3.6+ */";
                    val += "    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#" + jsonObject.menu[0] + "), color-stop(100%,#" + jsonObject.menu[1] + ")); /* Chrome,Safari4+ */";
                    val += "    background: -webkit-linear-gradient(top,#" + jsonObject.menu[0] + " 0%,#" + jsonObject.menu[1] + " 100%); /* Chrome10+,Safari5.1+ */";
                    val += "    background: -o-linear-gradient(top, #" + jsonObject.menu[0] + " 0%,#" + jsonObject.menu[1] + " 100%); /* Opera 11.10+ */";
                    val += "    background: -ms-linear-gradient(top, #" + jsonObject.menu[0] + " 0%,#" + jsonObject.menu[1] + " 100%); /* IE10+ */";
                    val += "    background: linear-gradient(to bottom, #" + jsonObject.menu[0] + " 0%,#" + jsonObject.menu[1] + " 100%); /* W3C */";
                    val += "    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#" + jsonObject.menu[0] + "', endColorstr='#" + jsonObject.menu[1] + "',GradientType=0 ); /* IE6-8 */";
                    val += "}";
                }

                if (typeof jsonObject.header_background != "undefined" && jsonObject.header_background) {
                    if (isHexColor(jsonObject.header_background)) {
                        jsonObject.header_background = "#" + jsonObject.header_background;
                    }
                    val += " #licensure header {";
                    val += "    background-color: " + jsonObject.header_background + "}";
                    val += "}";
                }

                val += "</style>";
                return val;
            },

            url: function (value) {
                if (value && value !== '' && value.substring(0, 4) !== 'http') {
                    return 'http://' + value;
                }
                else {
                    return value;
                }
            },

            nativeJSDateFormat: function (formatName) {
                switch (formatName) {
                    case "MM/DD/YY":
                        return { month: '2-digit', day: '2-digit', year: '2-digit' };
                    case "MM/DD/YYYY hh:mm":
                        // MM/DD/YYYY, hh:mm AM/PM
                        return { month: '2-digit', day: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' };
                    default:
                        // MM/DD/YYYY
                        return { month: '2-digit', day: '2-digit',  year: 'numeric' };
                }
            }
        }
    }])
;